import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import API from '../api';

function Signup() {
  const [message, setMessage] = useState('');
  const [cooldown, setCooldown] = useState(0);
  const [timerId, setTimerId] = useState(null);
  const [passwordErrors, setPasswordErrors] = useState([]);

  const location = useLocation();
  const selectedPlan = location.state?.selectedPlan;

  const [values, setValues] = useState({
    name: '',
    email: '',
    password: '',
    confirm_password: '',
    id: '',
    planName: 'Free Trial',
    price: '',
    acceptTerms: false, // ✅ Added for terms acceptance
  });

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Signup | TradeBarta.com";

  }, []);

    useEffect(() => {
    setCooldown(0);
  }, []);


  useEffect(() => {
    return () => {
      if (timerId) clearInterval(timerId);
    };
  }, [timerId]);

  const startCooldown = () => {
    setCooldown(120); // 2 minutes

    const interval = setInterval(() => {
      setCooldown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    setTimerId(interval);
  };

  const validatePassword = (password) => {
    const rules = [
      { regex: /.{8,}/, message: 'At least 8 characters' },
      { regex: /[A-Z]/, message: 'At least 1 uppercase letter' },
      { regex: /[a-z]/, message: 'At least 1 lowercase letter' },
      { regex: /[0-9]/, message: 'At least 1 number' },
      { regex: /[^A-Za-z0-9]/, message: 'At least 1 special character' },
    ];
    const failed = rules.filter(rule => !rule.regex.test(password));
    return failed.map(f => f.message);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
      setMessage('');

  const queryParams = new URLSearchParams(location.search);
  const refValue = queryParams.get("ref"); // "null" as string
  const actualRef = refValue === "null" ? null : refValue; 

  const errors = validatePassword(values.password);
    setPasswordErrors(errors);

    if (cooldown > 0) {
      setMessage(`Please wait ${cooldown} seconds before requesting again.`);
      return;
    }

    if (values.password !== values.confirm_password) {
      setMessage("Passwords do not match.");
      return;
    }

    if (errors.length > 0) {
      setMessage("Password does not meet security requirements.");
      return;
    }

    if (!values.acceptTerms) {
      setMessage("You must accept the Terms and Conditions and Privacy Policy to register.");
      return;
    }

    const payload = {
      ...values,
      planName: selectedPlan?.name || 'Free Trial',
      packageId: selectedPlan?.id || '',
      price: selectedPlan?.price || '',
      action: 'signup',
      ref: actualRef && actualRef !== 'null' ? actualRef : '', // send empty string instead of null
    };


    API.post('/api/signup_link', payload)
      .then((res) => {
        setMessage(res.data.message);
        startCooldown();
      })
      .catch((err) => {
        console.error(err);
        setMessage(err.message);
      });
  };

  return (

    <div className="page-container">
      <div className="content-wrap">
      <section className="navbar-area navbar-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <nav className="navbar navbar-expand-lg">
                <a className="navbar-brand" href="/">
                  <img width="200" height="70" src={require("../images/logo.png")} alt="Logo" />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne"
                  aria-controls="navbarOne" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="toggler-icon"></span>
                  <span className="toggler-icon"></span>
                  <span className="toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
                  <ul className="navbar-nav m-auto">
<li className="nav-item">
                  <a className="active page-scroll" href="/">Home</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/pricing">Pricing</a>
                </li>
                
                <li className="nav-item">
                  <a className="page-scroll" href="/referral">Refer and Win</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/faq">FAQ</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/contact">Contact Us</a>
                </li>             
              </ul>
                </div>
                <div className="navbar-btn">
                  <ul className="list-unstyled d-flex flex-wrap flex-md-row gap-2">
                    <li>
                      <a className="btn btn-primary w-100 w-md-auto" href="/login">LOGIN</a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section id="hero-area" className="header-area header-ten">
        <div className="header-inner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-12">
                <div className="home-slider">
                  <div className="form-container">
                    <h1>Sign Up</h1>
                    <form onSubmit={handleSubmit}>
                      <div>
                        <input
                          type='text'
                          name='name'
                          placeholder='Name'
                          required
                          onChange={(e) => setValues({ ...values, name: e.target.value })}
                        />
                      </div>
                      <div>
                        <input
                          type='email'
                          name='email'
                          placeholder='Email'
                          required
                          onChange={(e) => setValues({ ...values, email: e.target.value })}
                        />
                      </div>
                      <input
                          type='password'
                          name='password'
                          placeholder='Password'
                          required
                          onChange={(e) => {
                            setValues({ ...values, password: e.target.value });
                            setPasswordErrors(validatePassword(e.target.value));
                          }}
                        />
                        {passwordErrors.length > 0 && (
                          <ul style={{ color: 'red', fontSize: '13px', paddingLeft: 16, marginTop: 5 }}>
                            {passwordErrors.map((err, i) => <li key={i}>{err}</li>)}
                          </ul>
                        )}
                        <input
                          type='password'
                          name='confirm_password'
                          placeholder='Confirm Password'
                          required
                          onChange={(e) => setValues({ ...values, confirm_password: e.target.value })}
                        />

                      {/* ✅ Terms & Conditions Checkbox */}
                      <div className='form-footer'>
                        <label>
                          <input
                            type="checkbox"
                            checked={values.acceptTerms}
                            style={{
                                    transform: 'scale(1.5)', // Scale the checkbox 1.5x
                                    marginRight: '10px',     // Optional: spacing from label/text
                                    cursor: 'pointer'
                            }}
                            onChange={(e) =>
                              setValues({ ...values, acceptTerms: e.target.checked })
                            }
                            
                          />{' '}
                          I agree to the{' '}
                          <a href="/terms" target="_blank" rel="noopener noreferrer">
                            Terms & Conditions
                          </a>{' '}
                          and{' '}
                          <a href="/privacy" target="_blank" rel="noopener noreferrer">
                            Privacy Policy
                          </a>
                        </label>
                      </div>

                      <div>
                        <button type='submit' disabled={cooldown > 0}>
                          {cooldown > 0 ? `Wait ${cooldown}s to request again` : 'Register'}
                        </button>
                      </div>

                      {message && (
                        <p style={{ color: message.includes('success') ? 'green' : 'red' }}>
                          {message}
                        </p>
                      )}
                    </form>

                    <div className="form-footer">
                      Already have an account? <a href="/login">Login Here</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
</div>
<section className="footer-area footer-five">
  <div className="container">
    <div className="footer-top-content">
      
      {/* Links Section */}
      <div className="footer-links">
        <ul>
          <li>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-contact">
        <h4>Contact Us:</h4>
        <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
      </div>

    </div>
  </div>

  {/* Bottom copyright section */}
  <div className="footer-copyright">
    <div className="container">
      <p className="text-center">Copyright © 2025. All Rights Reserved</p>
    </div>
  </div>
</section>
      </div>
  );
}

export default Signup;
